import React, { useContext, useEffect, useState } from 'react';
import { useAuth0 } from "@auth0/auth0-react";

import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import FileDropBox from '../filedropbox/FileDropBox';
import ProjectContext from '../../contexts/ProjectContext';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useFetch } from '../auth/useFetch';


export default function UploadEDLForCDLInjectDialog(props) {

    const { anchorEl, filterClips, open, setOpen, updateParentList, title, hint, uploadFunc, cdlUploadSource } = props
    const projectContext = useContext(ProjectContext);
    const fetchWithAuth = useFetch()
    const [file, setFile] = useState('')

    const handleClose = () => {
        setOpen(false);
        setFile(null);
    };
    const handleSubmit = () => {
        if (!file) return;
        setOpen(false);
        uploadEDL();
        setFile(null);
    };
    
    const uploadEDL = async () => {
        var formdata = new FormData();
        formdata.append("file_upload", file);
        formdata.append('source', cdlUploadSource)
        formdata.append('format', 'Inject CDL into EDL')
        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow',
            headers: {
                'X-Project-ID': projectContext?.project_db
            },
        }
        const response = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/konsol/cdl/`, requestOptions)
            
        // Get filename from content-disposition header without consuming response
        let content_disposition = response.headers.get('content-disposition')
        const regex = /(?<=filename=").+(?=")/g
        const filename = content_disposition.match(regex)[0]

        // Consume response
        const responseBlob = await response.blob()
        const url = window.URL.createObjectURL(new Blob([responseBlob]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
    }


    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="lg"
                PaperProps={{
                    sx: {
                        width: "auto",
                        height: "auto",
                        backgroundColor: "#282828",
                    },
                }}
            >
                <DialogTitle>Upload EDL for Color Data Injection</DialogTitle>
                <DialogContent>
                    <FileDropBox
                        titleText={hint}
                        UploadIcon={<CloudUploadIcon sx={{ fontSize: 48, opacity: 0.4 }} />} // Replace with an actual icon if needed
                        setFile={setFile} />
                    {file && (
                        <Box
                            sx={{
                            mt: 2,
                            p: 1,
                            backgroundColor: "#222",
                            color: "white",
                            borderRadius: "4px",
                            fontSize: "0.95rem",
                            wordBreak: "break-all"
                            }}
                        >
                            {file.name}
                        </Box>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} sx={{ color: 'white' }}>
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} sx={{ color: 'white' }}>
                        Upload
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    )}